<template>
<div>
  <navigation></navigation>
  <!--Main contents-->
  <div class="box_center" id="page_x">
    <h2 class="shadow" style="float: left">Buy Picks</h2>
    <ul class="articles">
      <li v-if="(month === 8) && nhlFull">
        <div class="article">
        <a href="javascript:;" class="title_article">Featured: NHL Full Season Package</a>
        <p class="text_article">
          Full Season of NHL Hockey Picks! Only <strike v-if="mlbFull.current_price !== mlbFull.previous_price">${{nhlFull.previous_price}}</strike> ${{nhlFull.current_price}}.
          <br />
          <br />
          <purchase-button :package="nhlFull" :color="'gold'"></purchase-button>
        </p>
        </div>
        <div class="separator"></div>
      </li>
      <li v-if="(month === 2 || month === 3) && mlbFull">
        <div class="article">
        <a href="javascript:;" class="title_article">MLB Full Season Package</a>
        <p class="text_article">
          Full Season of MLB Baseball Picks! Only <strike v-if="mlbFull.current_price !== mlbFull.previous_price">${{mlbFull.previous_price}}</strike> ${{mlbFull.current_price}}.
          <br />
          <br />
          <purchase-button :package="mlbFull" :color="'gold'"></purchase-button>
          <!-- <paypal-button :package="mlbFull" :size="'medium'" :color="'gold'"></paypal-button> -->
        </p>
        </div>
        <div class="separator"></div>
      </li>
      <li v-if="month === 7 && nflFull">
      <div class="article">
      <a href="javascript:;" class="title_article">NFL Full Season Package</a>
      <p class="text_article">
      Full Season of NFL Picks! Includes Pre-season and Playoffs. Only <strike v-if="nflFull.current_price !== nflFull.previous_price">${{nflFull.previous_price}}</strike> ${{nflFull.current_price}}.
      <br />
      <br />
      <purchase-button :package="nflFull" :color="'gold'"></purchase-button>
      <!-- <paypal-button :package="nflFull" :size="'medium'" :color="'gold'"></paypal-button> -->
      </p>
      </div>
      <div class="separator"></div>
      </li>
      <li v-if="month === 7 && ncaafFull">
      <div class="article">
      <a href="javascript:;" class="title_article">NCAAF Full Season Package</a>
      <p class="text_article">
      Full Season of College Football Picks! Only <strike v-if="ncaafFull.current_price !== ncaafFull.previous_price">${{ncaafFull.previous_price}}</strike> ${{ncaafFull.current_price}}.
      <br />
      <br />
      <purchase-button :package="ncaafFull" :color="'gold'"></purchase-button>
      <!-- <paypal-button :package="ncaafFull" :size="'medium'" :color="'gold'"></paypal-button> -->
      </p>
      </div>
      <div class="separator"></div>
      </li>
      <li v-if="month === 9 && nbaFull">
        <div class="article">
        <a href="javascript:;" class="title_article">Featured: NBA Full Season Package</a>
        <p class="text_article">
        Full Season of NBA Picks! Includes Playoffs. Only <strike v-if="nbaFull.current_price !== nbaFull.previous_price">${{nbaFull.previous_price}}</strike> ${{nbaFull.current_price}}.
        <br />
        <br />
        <purchase-button :package="nbaFull" :color="'gold'"></purchase-button>
        <!-- <paypal-button :package="nflFull" :size="'medium'" :color="'gold'"></paypal-button> -->
        </p>
        </div>
        <div class="separator"></div>
      </li>
      <li v-if="month === 10 && ncaabFull">
      <div class="article">
      <a href="javascript:;" class="title_article">NCAAB Full Season Package</a>
      <p class="text_article">
      Full Season of NCAAB Picks! Includes Pre-season and Playoffs. Only <strike v-if="ncaabFull.current_price !== ncaabFull.previous_price">${{ncaabFull.previous_price}}</strike> ${{ncaabFull.current_price}}.
      <br />
      <br />
      <purchase-button :package="ncaabFull" :color="'gold'"></purchase-button>
      <!-- <paypal-button :package="ncaabFull" :size="'medium'" :color="'gold'"></paypal-button> -->
      </p>
      </div>
      <div class="separator"></div>
      </li>
      <li class="article">
        <div id="sport_dropdown" style="display:block;width:100%">
          <label for="sport">Sport:</label>
          <select name="sport" id="sports" v-model="selectedSport" @change="onSportChange">
            <option value="2343a835-82ae-4b4b-bb50-689912b97571">ALL</option>
            <option value="ba74ccae-1bfb-4a56-92d4-402a33d230bf">NFL</option>
            <option value="a2b8b898-5add-4522-a081-fb1030748310">NCAAF</option>
            <option value="c8695b24-eab6-4ee6-b8ab-d99418df69d6">MLB</option>
            <option value="fe1cf0cd-2368-41aa-aaed-12645fdc3ef9">NBA</option>
            <option value="51352c74-5dcc-4a32-b1b9-385c88e2fee6">NCAAB</option>
            <option value="a93e012c-e29a-49ab-901e-ed5396c87212">NHL</option>
            <option value="572cd870-23f9-41b5-80b3-11e1dd568ab5">UFC</option>
          </select>
        </div>
      </li>
      <li v-for="(package, index) in packages" :key="index">
        <div class="article">
          <a href="javascript:;" class="title_article">{{package.name}}</a>
          <p class="text_article">
            {{package.name}} {{package.description}} Only <strike v-if="package.current_price !== package.previous_price">${{package.previous_price}}</strike> ${{package.current_price}}.
            <br />
            <br />
            <purchase-button :package="package" :color="'gold'"></purchase-button>
        <!-- <paypal-button :package="allYear" :size="'medium'" :color="'gold'"></paypal-button> -->
          </p>
          </div>
          <div class="separator"></div>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import Nav from '../components/Nav'
import PaypalButton from '../components/paypalButton'
import PurchaseButton from '../components/purchaseButton'
import {PACKAGES} from '../constants'
export default {
  components: {
    'navigation': Nav,
    'paypal-button': PaypalButton,
    'purchase-button': PurchaseButton
  },
  computed: {
    packages () {
      return this.$store.state.packages.filter(p => p.sports_id === this.selectedSport && !p.special)
    },
    allWeek () {
      return this.$store.getters.package(PACKAGES.ALL_ONE)
    },
    allWeekPrice () {
      return this.allWeek ? this.allWeek.current_price : ''
    },
    allYear () {
      return this.$store.getters.package(PACKAGES.ALL_YEAR)
    },
    allYearPrice () {
      return this.allYear ? this.allYear.current_price : ''
    },
    allTwo () {
      return this.$store.getters.package(PACKAGES.ALL_TWO)
    },
    allTwoPrice () {
      return this.allTwo ? this.allTwo.current_price : ''
    },
    allMonth () {
      return this.$store.getters.package(PACKAGES.ALL_MONTH)
    },
    allMonthPrice () {
      return this.allMonth ? this.allMonth.current_price : ''
    },
    nhlFull () {
      return this.$store.getters.package(PACKAGES.NHL_FULL)
    },
    nflFull () {
      return this.$store.getters.package(PACKAGES.NFL_FULL)
    },
    ncaafFull () {
      return this.$store.getters.package(PACKAGES.NCAAF_FULL)
    },
    nbaFull () {
      return this.$store.getters.package(PACKAGES.NBA_FULL)
    },
    ncaabFull () {
      return this.$store.getters.package(PACKAGES.NCAAB_FULL)
    },
    mlbFull () {
      return this.$store.getters.package(PACKAGES.MLB_FULL)
    }
  },
  data () {
    return {
      month: new Date().getMonth(),
      selectedSport: '2343a835-82ae-4b4b-bb50-689912b97571'
    }
  },
  methods: {
    onSportChange (evt) {
      this.selectedSport = evt.target.value
    }
  },
  metaInfo: {
    title: 'Buy Picks'
  }
}
</script>

<style lang="css" scoped>
label {
  font-family: helvetica, tahoma, calibri, sans-serif;
  font-size: 16px;
}
select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 4px;
  margin-bottom: 12px;
  resize: vertical;
  background: white;
  font-size: 17px;
  color: #3a3a3a;
  font-family: helvetica, tahoma, calibri, sans-serif;
}
</style>



// WEBPACK FOOTER //
// Buy.vue?29386bdc